import { render, staticRenderFns } from "./Mindaugas.vue?vue&type=template&id=eff797a8&scoped=true&"
import script from "./Mindaugas.vue?vue&type=script&lang=js&"
export * from "./Mindaugas.vue?vue&type=script&lang=js&"
import style0 from "./Mindaugas.vue?vue&type=style&index=0&id=eff797a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff797a8",
  null
  
)

export default component.exports